// import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
})

import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify, {
  iconfont: 'md',
})

const opts = {}
export default new Vuetify(opts)